import { TAILLES, calculateJours, type TailleShirt } from '../types';
import './TshirtSelector.css';

interface TshirtSelectorProps {
    role: string;
    roleLabel: string;
    value: TailleShirt;
    onChange: (value: TailleShirt) => void;
}

export function TshirtSelector({ role, roleLabel, value, onChange }: TshirtSelectorProps) {
    const jours = calculateJours(value, role);

    return (
        <div className="tshirt-selector">
            <label className="tshirt-label">
                {roleLabel}
                <span className="tshirt-jours">{jours} jour{jours !== 1 ? 's' : ''}</span>
            </label>
            <div className="tshirt-buttons">
                {TAILLES.map((taille) => (
                    <button
                        key={taille}
                        type="button"
                        className={`tshirt-button ${value === taille ? 'active' : ''} ${taille === '—' ? 'neutral' : ''}`}
                        onClick={() => onChange(taille)}
                    >
                        {taille}
                    </button>
                ))}
            </div>
        </div>
    );
}
